// Mesma politica de App\Rules\PasswordPolicy da API do OAuth: pelo menos dois tipos entre letras, numeros e simbolos.
export function isWeakPassword(password) {
    const value = password ?? '';
    const types = [/\p{L}/u, /\p{N}/u, /[^\p{L}\p{N}]/u].filter((re) => re.test(value)).length;
    return types < 2;
}
